module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "news-mode"
  }, [_c('h3', [_vm._v("我们最新的动态")]), _vm._v(" "), (_vm.items.length > 0) ? _c('displayimg', {
    attrs: {
      "setcss": _vm.style,
      "images": _vm.items,
      "size": _vm.size
    }
  }) : _vm._e(), _vm._v(" "), _c('news', {
    attrs: {
      "newsdata": _vm.news
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "get-more"
  }, [(_vm.isShowMore) ? _c('router-link', {
    attrs: {
      "to": "/news_list"
    }
  }, [_vm._v("> 更多 <")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49e110e1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/NewsSection.vue
// module id = 176
// module chunks = 1